import {  Alert, Box, Button, DialogActions, DialogContent, DialogTitle,  Grid,  LinearProgress,  MenuItem,  Paper, Select, Snackbar, SnackbarCloseReason} from '@mui/material';
import { useState } from 'react';
import { AutoCompleteProdutorListagemCitros } from '../../../shared/forms';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import dayjs, { Dayjs } from 'dayjs';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LCDPRService } from '../../../shared/services/api/fiscal/LCDPR/LCDPRService';
import RelatorioCaixa from './RelatorioCaixa';
import RelatorioLCDPR from './RelatorioLCDPR';
           
export const RelatorioslcdprCitros: React.FC = () => {                      
  const [isLoading, setIsLoading] = useState(false);         
  const [uidProdutor, setUidProdutor] = useState(0);       
  const [nomeProdutor, setUidNomeProdutor] = useState('');    
  const [tipo, setTipo] = useState('caixa');                   
  const [dataInicial, setDataInicial] = useState<Dayjs | null>(dayjs()); 
  const [dataFinal, setDataFinal] = useState<Dayjs | null>(dayjs());     
  const [openmsg, setOpenmsg] = useState(false);
  const [msg, setMsg] = useState('');
  const [tms, setTms] = useState<'warning' | 'error'  | 'info'  | 'success'>('warning');  
      
  const handleCloseMsg = (
    event?: React.SyntheticEvent | Event,
    reason?: SnackbarCloseReason,
  ) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenmsg(false);       
  };  
                 
  const handleSave = () => {                    
    if(tipo === 'lcdpr'){
      LCDPRService                 
        .RelatorioLCDPRCitros(uidProdutor, dayjs(dataInicial).format('DD/MM/YYYY'), dayjs(dataFinal).format('DD/MM/YYYY'))   
        .then((result) => {           
          setIsLoading(false);                 
          if (result instanceof Error) {                
            setTms('error');
            setMsg(result.message);
            setOpenmsg(true);                   
          }else {  
            if(result.length > 0){  
              RelatorioLCDPR(result, nomeProdutor, `Período :${dayjs(dataInicial).format('DD/MM/YYYY')} a  ${dayjs(dataFinal).format('DD/MM/YYYY')}`);  
            }else{
              setTms('warning');
              setMsg('Nenhum registro encontrado');
              setOpenmsg(true);   
            }
          }                   
        });              
    }else{     
      LCDPRService                 
        .RelatorioCaixaCitros(uidProdutor, tipo, dayjs(dataInicial).format('DD/MM/YYYY'), dayjs(dataFinal).format('DD/MM/YYYY'))   
        .then((result) => {           
          setIsLoading(false);                       
          if (result instanceof Error) {                         
            setTms('error');
            setMsg(result.message);
            setOpenmsg(true);                        
          }else {  
            if(result.length > 0){  
              RelatorioCaixa(result, nomeProdutor, `Período :${dayjs(dataInicial).format('DD/MM/YYYY')} a  ${dayjs(dataFinal).format('DD/MM/YYYY')}`);  
            }else{
              setTms('warning');
              setMsg('Nenhum registro encontrado');
              setOpenmsg(true);     
            }
          }                
        });        
    }                                  
  };          

  const handleProdutor = (uidprodutor: number | undefined) => {    
    if (uidprodutor != null) {     
      setUidProdutor(uidprodutor);                  
    }else{                       
      setUidProdutor(0);                         
    }                 
  };  

  const handleNomeProdutor = (nome: string | undefined) => {    
    if (nome != null) {     
      setUidNomeProdutor(nome);                  
    }else{                       
      setUidNomeProdutor('');                         
    }                 
  };  

  return (
    <Box  alignItems="center" width='auto' alignContent='center' height="auto"  display="flex" flexDirection="column"  >
      <Snackbar anchorOrigin={{ vertical: 'top', horizontal: 'center' }} open={openmsg}  autoHideDuration={900} onClose={handleCloseMsg}>
        <Alert
          onClose={handleCloseMsg}
          severity={tms}
          variant="filled"
          sx={{ width: '100%' }}
        >
          {msg}
        </Alert>
      </Snackbar>
      <Box gap={1}  padding={1} paddingX={2} display="flex" alignItems="center" alignSelf='center' width='80%' height="20%" margin={1}  alignContent='center'></Box>
      <Box   width='auto' alignItems="center"  component={Paper} height="auto" 
        alignContent='center'>       
        <DialogTitle>Relatório do LCDPR Citros</DialogTitle>
        <DialogContent  dividers>    
          {isLoading && (           
            <Grid item>  
              <LinearProgress variant='indeterminate' />  
            </Grid>                      
          )}   
          <Grid item container direction="row" gap={1}>  
            <AutoCompleteProdutorListagemCitros
              uuidprodutor={handleProdutor}   
              nome={handleNomeProdutor}  
            />  
            <Select         
              size='small'
              sx={{ width: '20ch' }}
              value={tipo}
              onChange={(event) => setTipo(event.target.value)}
            >   
              <MenuItem value={'caixa'}>Caixa</MenuItem>    
              <MenuItem value={'competencia'}>Competencia</MenuItem>
              <MenuItem value={'lcdpr'}>LCDPR</MenuItem>
              <MenuItem value={'faltapagamento'}>Falta Pagamento</MenuItem>
            </Select>        
          </Grid>   
          <Grid item container direction="row" marginTop={2} gap={1}>               
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                format='DD/MM/YYYY'
                sx={{ width: '31ch' }}
                value={dataInicial}
                onChange={(newValue) => setDataInicial(newValue)} 
                label='Data Inicial'
                slotProps={{
                  textField: {    
                    size:'small',
                  }
                }}
              />
            </LocalizationProvider>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                format='DD/MM/YYYY'
                sx={{ width: '31ch' }}
                value={dataFinal}
                onChange={(newValue) => setDataFinal(newValue)} 
                label='Data Final'
                slotProps={{
                  textField: {    
                    size:'small',
                  }
                }}
              />
            </LocalizationProvider>
          </Grid> 
        </DialogContent>     
        <DialogActions>
          <Button sx={{ minWidth:'30%'  }} variant='outlined' autoFocus onClick={handleSave}>Visualizar</Button>
        </DialogActions>
      </Box>
    </Box>
  );
};   